import React, { useContext } from 'react'
import { useDispatch } from 'react-redux'

import { addNewCountry } from '../../redux/actions'
import { ThemeContext } from '../../contexts'
import { MainTableProps, Country } from '../../types'
import TableHeader from '../TableHeader/index'
import TableRow from '../TableRow/index'
import './style.scss'

const MainTable = ({
  sortCountries,
  isNameReversing,
  isPopReversing,
  isRegionReversing,
  countries,
}: MainTableProps) => {
  const { theme } = useContext(ThemeContext)
  const dispatch = useDispatch()

  const addCountry = (country: any) => {
    // alerts BUTTON
    const { flags, name, population, languages, region } = country

    const addedCountry: Country = {
      flags: flags,
      name: name.common,
      population: population,
      languages: languages,
      region: region,
    }
    dispatch(addNewCountry(addedCountry))
  }
  return (
    <table
      className="countries-container"
      style={{ backgroundColor: theme.backgroundColor }}
    >
      <thead>
        <TableHeader
          sortCountries={sortCountries}
          isNameReversing={isNameReversing}
          isPopReversing={isPopReversing}
          isRegionReversing={isRegionReversing}
        />
      </thead>
      <tbody>
        {countries.map((country: any) => (
          <TableRow
            key={country.name}
            flags={country.flags}
            name={country.name.common}
            capital={country.capital}
            population={country.population}
            languages={country.languages}
            region={country.region}
            maps={country.maps}
            addCountry={() => addCountry(country)}
          />
        ))}
      </tbody>
    </table>
  )
}

export default MainTable
